import { useState, useEffect } from "react";
import { normalizeBackendUrl } from "@/lib/api";

interface AccountStatus {
  paused: boolean;
  pauseExpiresAt?: string | null;
}

export function useAccountPaused() {
  const [status, setStatus] = useState<AccountStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const BACKEND_URL = normalizeBackendUrl(import.meta.env.VITE_BACKEND_URL as string | undefined);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const token = localStorage.getItem("token");

        const res = await fetch(`${BACKEND_URL}/api/user/account-status`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (res.status === 401) {
          localStorage.removeItem("token");
          window.location.href = "/";
          return;
        }

        if (!res.ok) {
          setLoading(false);
          return;
        }

        const data = await res.json();

        if (!cancelled) {
          const paused = data?.isPaused ?? data?.paused ?? false;

          setStatus({
            paused: !!paused,
            pauseExpiresAt: data.pauseExpiresAt ?? null,
          });
        }

      } catch (err) {
        console.warn("[useAccountPaused] Failed to fetch account status:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    check();
    return () => { cancelled = true; };
  }, [BACKEND_URL]);

  return {
    paused: status?.paused ?? false,
    pauseExpiresAt: status?.pauseExpiresAt ?? null,
    loading,
  };
}